import { render, staticRenderFns } from "./SanityRichTextImageSerializer.vue?vue&type=template&id=37bcb144&scoped=true&"
import script from "./SanityRichTextImageSerializer.vue?vue&type=script&lang=ts&"
export * from "./SanityRichTextImageSerializer.vue?vue&type=script&lang=ts&"
import style0 from "./SanityRichTextImageSerializer.vue?vue&type=style&index=0&id=37bcb144&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bcb144",
  null
  
)

export default component.exports